import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { queryKeys, staleTimes } from '../config/queryClient';

/**
 * Hook para obtener los banners de una sucursal
 * 
 * @param {number} shopBranchId - ID de la sucursal
 * @param {object} options - Opciones adicionales
 * @returns {object} - { data: banners[], isLoading, error }
 */
export const useBanners = (shopBranchId, options = {}) => {
  return useQuery({
    queryKey: queryKeys.banners(shopBranchId),
    
    queryFn: async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BANNER_IMAGES_GET_ROUTE}/${shopBranchId}`
      );
      return response.data;
    },
    
    enabled: !!shopBranchId,
    
    // Banners cambian semanalmente o menos
    staleTime: staleTimes.moderate, // 10 minutos
    
    cacheTime: 30 * 60 * 1000, // 30 minutos
    
    ...options,
  });
};
